import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 8,
    // marginBottom: 8,
    border: `1px solid ${theme.palette.grey[300]}`
  },
  adminRoot: { opacity: '50%' },
  main: { padding: theme.spacing(2) },
  top: {
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.grey[300]}`
  },
  bottomm: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column'
  },
  grey: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr 1fr',
      rowGap: 8
    },
    padding: theme.spacing(1),
    background: theme.palette.grey[200],
    borderRadius: 6,
    marginTop: 8
  },
  card: {
    display: 'flex',
    borderRadius: 8,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    border: `1px solid ${theme.palette.grey[300]}`
  },
  image: {
    width: 191,
    height: 137,
    [theme.breakpoints.down('sm')]: {
      width: 100,
      height: 80
    },
    borderRadius: '8px 0  0 8px',
    objectFit: 'cover'
  },
  content: {
    display: 'grid',
    gridTemplateColumns: '3fr 1.5fr',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      height: 80,
      gridTemplateColumns: '1fr'
    },
    height: 137,
    padding: theme.spacing(2)
  },
  left: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  textColor: {
    fontWeight: 600,
    color: theme.palette.grey[600],
    [theme.breakpoints.down('sm')]: {
      fontSize: 10
    },
    display: 'flex',
    verticalAlign: 'middle'
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    flex: 3
  },
  payment: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  title: {
    fontSize: 20,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16
    },
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  location: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5)
  },
  paymentChip: {
    marginTop: theme.spacing(1),
    padding: 2,
    background: theme.palette.grey[200],
    width: 'fit-content',
    '& .MuiChip-label': {
      fontSize: 13,
      fontWeight: 500,
      color: theme.palette.grey[600]
    }
  },
  right: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end'
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  dateLabel: {
    color: theme.palette.grey[600],
    marginRight: 6,
    fontWeight: 600
  },
  dateValue: {
    fontWeight: 500,
    color: theme.palette.text.primary
  },
  stars: {
    display: 'flex',
    justifyContent: 'flex-start',
    color: '#fbc02d',
    height: '60%',
    alignItems: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      marginTop: 8
    }
  },
  bottom: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(0.5),
    height: '40%',
    alignItems: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start'
    },
    justifyContent: 'end'
  },
  check: { display: 'flex', flexDirection: 'row' },
  icon: { fontSize: 18 },
  blackText: { fontWeight: 600, color: theme.palette.text.primary },
  section: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: theme.spacing(1),
    gap: 8,
    borderLeft: `2px solid ${theme.palette.grey[400]}`
  },
  greyTex: { fontWeight: 600, color: theme.palette.grey[600] }
}))
export default useStyles
